// These values are copied from src/lib/phoneSupport/services/finders.ts in the web repo.
// Make sure these are synced. Longer term, query the backend for these values.
// 1-888-4-Fi-Dogs Phone Line
export const PHONE_SUPPORT_NUMBER = '+1(888)434-3647';
// The ZenDesk name assigned to the digital support line
export const DIGITAL_SUPPORT_LINE_NAME = 'FiDigitalSupportLine';
